import React from 'react';

type CoverImageProps = {
  photoUrl: string;
};

const CoverImage: React.FC<CoverImageProps> = ({ photoUrl }) => (
  <div className="px-10">
    <div className="md:w-[276px] md:mx-auto aspect-4/5 rounded-lg shadow-xl overflow-hidden">
      <img
        src={photoUrl}
        className="w-full aspect-4/5 object-cover"
        data-testid="cover-image"
      />
    </div>
  </div>
);

export default CoverImage;
